import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTarget, FiSearch, FiCode } = FiIcons;

const SystemAuthority = () => {
  const authorities = [
    {
      icon: FiSearch,
      title: "Real Trade Behaviour",
      copy: "Designed around how customers actually search, scan, and decide in local service markets."
    },
    {
      icon: FiTarget,
      title: "Conversion-First Structure",
      copy: "Every section exists to remove doubt and drive one action: enquiry."
    },
    {
      icon: FiCode,
      title: "Field-Tested Frameworks",
      copy: "Built from analysing high-performing trade pages across multiple industries."
    }
  ];

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Built on Proven Trade Conversion Patterns
          </h2>
          <p className="text-xl text-white/60 max-w-3xl mx-auto">
            This system is engineered from real-world trade websites, local SEO behaviour, and high-converting service funnels. Every page is built on patterns that already work in the trade market.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {authorities.map((auth, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={auth.icon} className="w-6 h-6 text-blue-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4">{auth.title}</h3>
              <p className="text-white/60 leading-relaxed">{auth.copy}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemAuthority;